import { Routes, Route } from "react-router-dom";
import Mappings from "./Mappings";

const index = () => {
	return (
		<Routes>
			<Route index element={<Mappings />} />
		</Routes>
	);
};

export default index;
